import { render } from "./StatCardPlaceholder.vue?vue&type=template&id=fb91b6d4"
import script from "./StatCardPlaceholder.vue?vue&type=script&lang=js"
export * from "./StatCardPlaceholder.vue?vue&type=script&lang=js"

import "./StatCardPlaceholder.vue?vue&type=style&index=0&id=fb91b6d4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__